module.exports = __webpack_public_path__ + "static/img/shengcai.1a705dad.png";